const Notifier = {
  state: {
    event_sounds: {
      server_connected: "alert-info-1",
      server_disconnected: "alert-info-2",
      successful_ping: "alert-info-3",
      unsuccessful_ping: "alert-info-5",
      important_rule: "filling-your-inbox",
      action_failed: "alert-info-2",
      price_guard_alert: "oh-finally",
      trade_watcher_alert: "beyond-doubt-2",
    },
  },
  mutations: {
    updateEventSound(state, mutatedSound) {
      state.event_sounds[mutatedSound.eventName] = mutatedSound.sound;
    },
    // updateEventSound(state, event, sound) {
    //   state.event_sounds = { ...state.event_sounds, event: sound };
    // }
  },
  getters: {
    getEventSoundByName: (state) => (name) => {
      return state.event_sounds.hasOwnProperty(name)
        ? state.event_sounds[name]
        : "alert-info-1";
    },
    getEventsAndSounds: (state) => Object.entries(state.event_sounds),
    getEventsNames: (state) => Object.keys(state.event_sounds),
  },
};

export default Notifier;
